module.exports = __webpack_public_path__ + "img/SER-A-3-III.54147558.png";